import styled from "styled-components";
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import { NavLink } from "react-router-dom";

import { COLORS } from "../../../../../constants/design";

export const TooltipCustom = styled(Tooltip)`
left: 6px;
  &.MuiTooltip-popper{
    left: 6px;
    .MuiTooltip-tooltip{

    }
  }
`;

export const Container = styled.div`
  display: flex;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const WrapperDrawerAction = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

export const HomeIconWrapper = styled.span`
  width: 15px;
  height: 15px;
`;

export const DashboardIconWrapper = styled.span`
  width: 14px;
  height: 14px;
`;

export const EducationIconWrapper = styled.span`
  width: 21px;
  height: 17px;
  svg path{
    stroke: transparent;
  }
`;

export const FeedbackIconWrapper = styled.span`
  width: 16px;
  height: 16px;
`;

export const UserListIconWrapper = styled.span`
  width: 16px;
  height: 16px;
`;

export const EditIconWrapper = styled.span`
  width: 16px;
  height: 16px;
`;

export const MenuIconWrapper = styled.span`
  width: 12px;
  height: 12px;
  display: flex;
`;

export const IconButtonCustom = styled(IconButton)`
  &&{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 46px;
    height: 46px;
    margin-right: 7px;
    margin-left: 7px;
    margin-bottom: 7px;
    .MuiIconButton-label{
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const ListItemTextCustom = styled(ListItemText)`
  &&{
    width: 100%;
    height: 100%;
    overflow: visible;
    margin: 0;
    display: flex;
    align-items: center;
    align-self: center;
    span{
      font-size: 13px;
      font-weight: 600;
      color: #2B2B2B;
      letter-spacing: 0;
      line-height: 10px;
      transition: all .3s ease-out;
    }
  }
`;

export const ListItemIconCustom = styled(ListItemIcon)`
  &&{
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: auto;
    width: 46px;
    height: 46px;
    max-width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: initial;
    border-radius: 6px;
    background-color: transparent;
    transition: all .2s ease-out;
    svg{
      transition: all .2s ease-out;
      path{
        transition: all .2s ease-out;
      }
    }
  }
`;


export const ListItemCustomHome = styled.a`
  &&{
    display: flex;
    text-decoration: none;
    padding: 0;
    margin: 0 0 10px 7px;
    width: calc(100% - 14px);
    border-radius: 6px;
    transition: all .2s ease-out;
    &:first-child{
      margin: 0 0 30px 7px;
    }
    &:hover,
    &.isActive{
      background-color: #2768B3;
      ${ListItemIconCustom}{
        svg{
          &.homeIcon{
            path{
              stroke: #ffffff;
            }
          }
          path{
            fill: #ffffff;
          }
        }
      }
      ${ListItemTextCustom}{
        span{
          color: #ffffff;
        }
      }
    }
  }
`;

export const ListItemCustom = styled(NavLink)`
  &&{
    display: flex;
    text-decoration: none;
    padding: 0;
    margin: 0 0 10px 7px;
    width: calc(100% - 14px);
    border-radius: 6px;
    transition: all .2s ease-out;
    &:hover,
    &.isActive{
      background-color: #2768B3;
      ${ListItemIconCustom}{
        svg{
          &.homeIcon{
            path{
              stroke: #ffffff;
            }
          }
          path{
            fill: #ffffff;
          }
        }
      }
      ${ListItemTextCustom}{
        span{
          color: #ffffff;
        }
      }
    }
  }
`;

export const ListCustom = styled(List)`
  &&{
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

export const DrawerCustom = styled(Drawer)`
  &&{
    border: 0;
    flex-shrink: 0;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    width: ${props => props.open ? 250 : 60}px;
    transition: ${props => props.open ? 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms' : 'width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'};
    overflow-x: ${props => props.open ? 'initial' : 'hidden'};
    .MuiDrawer-paper{
      border: 0;
      background-color: #F5FAFF;
      /* background-color: #FBFDFF; */
      display: flex;
      justify-content: space-between;
      width: ${props => props.open ? 250 : 60}px;
      transition: ${props => props.open ? 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms' : 'width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'};
      overflow-x: ${props => props.open ? 'initial' : 'hidden'};
    }
    ${ListItemTextCustom} {
      width: ${props => props.open ? '100%' : '0'};
      overflow: ${props => props.open ? 'visible' : 'hidden'};
    }
  }
`;

export const NagivationButton = styled.div`
  cursor: pointer;
  display: flex;
  text-decoration: none;
  padding: 0;
  margin: 0 0 10px 7px;
  width: calc(100% - 14px);
  border-radius: 6px;
  transition: all .2s ease-out;
  &:first-child{
    margin: 0 0 30px 7px;
  }
  &:hover,
  &.isActive{
    background-color: #2768B3;
    ${ListItemIconCustom}{
      svg{
        &.taskValidatedIcon{
          path{
            stroke: #ffffff;
          }
        }
        path{
          fill: #ffffff;
        }
      }
    }
    ${ListItemTextCustom}{
      span{
        color: #ffffff;
      }
    }
  }
`;

export const NagivationGroup = styled.div`
  border-bottom: 1px solid ${COLORS.LIGHT_GREY_2};
  padding-top: 10px;
`;

export const NagivationGroupTitle = styled.div`
  height: ${props => props.open ? '40px' : '0px'};
  transform: ${props => props.open ? 'scaleY(1)' : 'scaleY(0)'};
  opacity: ${props => props.open ? '1' : '0'};
  padding: ${props => props.open ? '5px 20px' : '0px'};
  transform-origin: top;
  transition: all .2s ease-out;
  font-weight: 600;
`;
